module.exports = __webpack_public_path__ + "static/media/all.7364701e.jpg";